<template>
  <div class="container">
    <Nav></Nav>
    <div class="banner"></div>
    <div class="bread">
      <div>
        <div class="bread-mulu">
          <img
            src="../assets/images/newlist-mulu.png"
            alt=""
            @click="$router.push({ path: '/' })"
            style="cursor: pointer"
          />
          <span></span>
          <p>产品介绍</p>
          <span></span>
          <p class="br-name">IHEC智能家考系统</p>
        </div>
      </div>
    </div>
    <div class="con">
      <img src="../assets/images/ihec.png" alt="" />
      <!-- <video :src="bannervideo" controls autoplay></video> -->
      <div id="playvideo" class="playvideo"></div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Nav from "@/components/topNav.vue";
import Footer from "@/components/footer.vue";
import config from "../../config/index";
export default {
  components: {
    Nav,
    Footer,
  },
  data() {
    return {
      bannervideo: "",
    };
  },
  methods: {
      createPlayer() {
        this.test = document.getElementById("playvideo");
        this.player = window.createCCH5Player({
          vid: "8B7C7052AB46BE3FFC9558351D509E7C",
          siteid: "91C21EF3AD3F9C3A",
          autoStart: true,
          width: "100%",
          height: "580px",

          mediatype: 1,
          playtype: 1,
          autoStart: true,
          realAutoPlay: true,
          // 'watchStartTime': tmpStudyLastTime,
          closeHistoryTime: 1, //设置是否关闭记忆播放功能。0，使用； 1，关闭
          defaultDf: 10, // 参数配置10（标清）
          // 'progressbar_enable': study.isAllowedFast ? 1 : 0,//为0时禁止进度拖动，为1时允许拖动快进退
          rate_allow_change: false, //是否允许切换倍速
          isShare: false,
          showHdBtn: false, //默认 true 为false时不显示按钮
          loop: true, //是否循环播放

          parentNode: this.test,
        });
      }
  },
  mounted() {
    this.bannervideo =
      (process.env.NODE_ENV === "production"
        ? ".." + config.build.assetsPublicPath
        : "../") + "static/banner.mp4";

    if (window.ccH5PlayerJsLoaded) {
      this.createPlayer();
    }
  },
};
</script>

<style scoped>
.container {
  background-color: #f7f7f7;
}
.banner {
  width: 100%;
  height: 380px;
  background: url("../assets/images/pro-ihec.png") no-repeat center;
  overflow: hidden;
}
.bread {
  width: 100%;
  height: 56px;
  background: #fbfbfb;
}
.bread div {
  width: 1200px;
  margin: 0px auto;
}
.bread .bread-mulu {
  width: 219px;
  float: left;
  line-height: 56px;
  display: flex;
  justify-content: space-between;
}
.bread .bread-mulu img {
  width: 12px;
  height: 12px;
  align-self: center;
  vertical-align: 0px;
}
.bread .bread-mulu span {
  display: inline;
  width: 0px; /*  宽高设置为0，很重要，否则达不到效果 */
  height: 0px;
  border: 5px solid #727272;
  border-top-color: transparent; /*设置透明背景色*/
  border-right-color: transparent;
  border-bottom-color: transparent;
  align-self: center;
  margin-right: -15px;
}
.bread .bread-mulu .br-name {
  color: #b00000;
}
/* .coon{
     clear: both;
    display: block;
    overflow: hidden;
} */
.con {
  width: 1200px;
  height: 3722px;
  margin: 10px auto 30px;
  position: relative;
}
.con img {
  width: 1200px;
  position: absolute;
}
.playvideo {
  position: absolute;
  z-index: 999;
  width: 1036px;
  top: 880px;
  left: 78px;
}
</style>



// WEBPACK FOOTER //
// src/views/introduceIhec.vue